import "./button.scss";

function Button(props) {
  return (
    <button
      className={`button${props.className ? ` ${props.className}` : ""}${
        props.hideMobile ? ` button--mobile-hidden` : ""
      }`}
      onClick={
        typeof props.onClick === "function" ? () => props.onClick() : null
      }
      aria-label={props.ariaLabel || null}
    >
      <div className="button__bg" />
      <span className="button__text">{props.text}</span>
    </button>
  );
}

export default Button;
